let hasJustLoggedIn = false;

window.addEventListener(
  "AsosAuthClient.onLoggedIn",
  () => (hasJustLoggedIn = true)
);

export default () => hasJustLoggedIn;
